import React, { useEffect, useState } from "react";
import "../Css/Values.css";

const ValueCultivation = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const timer = setTimeout(() => {
      setAnimate(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`cultivation-container ${animate ? "animate" : ""}`}>
      <h2 className="cultivation-title">
        <span className="gray">VALUES</span>{" "}
        <span className="green">CULTIVATION</span>
        <div className="underline" />
      </h2>

      <p className="cultivation-description">
        After the seed of values is sown and heart becomes fertile through
        knowledge transmission, the background is set for the cultivation phase
        which aims to help an individual cultivate the values in his life and
        embellish his personality.
      </p>

      <div className="cultivation-content">
        <div className="cultivation-list">
          <h3>Values Cultivation Phase Topics</h3>
          <ul>
            <li>3 Pillars of Trustworthy Character</li>
            <li>Making Heart Malleable</li>
            <li>Love and Cooperation Among leaders</li>
            <li>Accepting Responsibility</li>
            <li>The Magic Carpet for Relationships</li>
            <li>Compassion and care</li>
            <li>Integrity and Honesty</li>
            <li>Punctuality and Cleanliness</li>
            <li>Understanding Your Parents</li>
            <li>
              Responsible Citizenship—duties towards self-development, for
              others and community
            </li>
            <li>Art of Leading leaders</li>
            <li>Team Building and Responsibility sharing</li>
            <li>Attitude of Gratitude</li>
            <li>Social Dealings—Dealings with Seniors, Equals and Juniors</li>
            <li>Developing Respect and Gratitude</li>
            <li>Festival Meditations</li>
            <li>A LIFE OF Likes</li>
            <li>Simple Living, High thinking</li>
            <li>Overcoming Fear</li>
            <li>Overcoming Anger</li>
            <li>Managing Fear: Life’s Exams Fear and Fear of Expectations</li>
          </ul>
        </div>
        <div className="cultivation-image">
          <img
            src="/assets/edu-training/value-cultivation.jpg"
            alt="Cultivation Graphic"
          />
        </div>
      </div>
    </div>
  );
};

export default ValueCultivation;
